import { Component, OnInit, AfterViewInit } from '@angular/core';
import { MasterService } from 'app/services/master/master.service';
import { MstNotificationModel } from 'app/model/mst.notification.model';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class MainView implements OnInit {

    notifications: MstNotificationModel[];

    constructor(private masterService: MasterService, private routerInfo: ActivatedRoute) {
        
        let bodyCss = document.querySelector('body').classList;
        bodyCss.add('show-home');
        bodyCss.add('sidebar-hidden');
    }

    async ngOnInit() {
        try {
            this.notifications = await this.masterService.getNotifications();

        } catch(err) {
            console.error(err.message);
        }
    }
}



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/views/main/main.component.ts